import React from "react";
import {MonthlyRevenueReportsAddList} from "../reportsView";

const MonthlyRevenueReportsAdd = () => { 
  return (
    <div className="">
      <main className="content">
        <div className="container-fluid p-0">
          <h1>Monthly Revenue Reports Add</h1>
          <p style={{color: 'red'}}>Report for prior month gets finalized by the 15th of every consecutive month.</p>
          <hr />
          <MonthlyRevenueReportsAddList />
        </div>
      </main>
    </div>
  );
};

export default MonthlyRevenueReportsAdd;